<template>
  <el-dialog title="批量购票" :visible.sync="dialogFormVisible" width="600px">
    <el-form
      ref="dataForm"
      :model="temp"
      label-position="left"
      label-width="100px"
      style="margin: 0 30px"
    >
      <template>
        <el-form-item label="票行ID">
          <el-input
            v-model="temp.tc_ticket_id"
            placeholder="请输入票行ID"
            @blur="handleTicketName"
          />
        </el-form-item>
        <el-form-item label="票行名称">
          <el-input v-model="temp.ticket_name" placeholder="请输入票行ID" readonly />
        </el-form-item>
        <el-form-item label="项目">
          <el-select v-model="temp.project_id" filterable placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in project_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游玩日期">
          <el-date-picker
            v-model="temp.travel_date"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>

        <el-form-item label="购票手机号">
          <el-input
            type="mobile"
            v-model="temp.mobile"
            maxlength="11"
            placeholder="请输入购票手机号"
          />
        </el-form-item>
        <el-form-item label="购票数量">
          <el-input v-model="temp.ticket_num" :placeholder="placeholder" />
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { batch } from '@/api/preTicket'
import { getTicketInfo } from '@/api/common'
import { getList as getProjectList } from '@/api/projects'
const rule = [{ required: true, message: '必填项不能为空' }]
export default {
  name: 'PreTicketBatch',
  data() {
    return {
      dialogFormVisible: false,
      temp: {
        tc_ticket_id: undefined,
        ticket_name: '',
        project_id: '',
        travel_date: '',
        mobile: '',
        ticket_num: ''
      },
      placeholder: '请输入购票数量',
      rules: {
        tc_ticket_id: rule,
        mobile: rule,
        project_id: rule,
        travel_date: rule
      },
      project_options: []
    }
  },
  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
  },
  methods: {
    // 添加
    handleCreate() {
      this.temp = {
        tc_ticket_id: undefined,
        ticket_name: '',
        project_id: '',
        travel_date: '',
        mobile: '',
        ticket_num: ''
      }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    /**
     * @description: 获取票行名称
     * @return {*}
     */
    handleTicketName() {
      this.temp.tc_ticket_id &&
        getTicketInfo({ ticket_id: this.temp.tc_ticket_id }).then((res) => {
          console.log(res)
          const { ticket_name, id_card_num } = res.data
          this.temp.ticket_name = ticket_name
          this.temp.ticket_num = id_card_num
          if (id_card_num > 0) this.placeholder = '请输入购票数量(不超过' + id_card_num + '张)'
        })
    },

    // 保存
    saveData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (!/^(1[3-9]\d{9})$/.test(this.temp.mobile)) {
            return this.$message.error('请输入正确的手机号!')
          }
          const d = JSON.parse(JSON.stringify(this.temp))
          batch(d).then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: '成功',
              message: '添加成功',
              type: 'success'
            })
          })
        }
      })
    }
  }
}
</script>
